module.exports = __webpack_public_path__ + "img/badge_salabam_wiaggiare.15d763b4.png";